import React, { useRef } from "react";
import { InputBase } from "components/Atoms/formInputs/InputBase";
import { useValidate } from "formvalidation/hooks";
import { CommonInputProps } from "./models";


const FirstNameInput = (props: CommonInputProps) => {
  const { validatorKey, innerRef, ...rest } = props;
  const ownRef = useRef<HTMLInputElement>(null);
  const inputRef = innerRef ?? ownRef;

  const validateFirstName = async () => {
    if (props.value.trim().length === 0) {
      return RESX.GeneralWarnings.PleaseFillInThisField;
    }

    return true;
  };

  const validation = useValidate({
    key: validatorKey,
    title: RESX.Contact.FirstName,
    value: props.value,
    validate: validateFirstName,
    ref: inputRef
  });

  return <InputBase
    {...rest}
    ref={inputRef}
    error={validation.error.errorMessage ?? validation.error.hasError}
    maxLength={serverReference.constants.personName.maxFirstNameLength}
    placeholder={RESX.Contact.FirstName}
  />
};

export default FirstNameInput;
